import {ControlledToggle} from '@hm/fundamental'
import {Typography, Switch, Box} from '@mui/material'
import clsx from 'clsx'
import React from 'react'
import {Controller, FieldValues} from 'react-hook-form'

import {useTranslation} from '../../../hooks/useTranslation'
import {UserInformationInputSkeleton} from '../Skeleton/UserInformationInputSkeleton'

import {useStyles} from './BlocklistNotificationsInput.styles'
import {UserInformationProps} from './types'

type BlocklistNotificationsInputProps<T extends FieldValues> = UserInformationProps<T> & {
  showNewUserProfile?: boolean
}
export const BlocklistNotificationsInput = <T extends FieldValues>({
  readonlyMode,
  formMethods,
  isLoading,
  name,
  showNewUserProfile
}: BlocklistNotificationsInputProps<T>) => {
  const {t} = useTranslation()

  const classes = useStyles()

  if (isLoading) {
    return <UserInformationInputSkeleton />
  }

  return (
    <Box style={{marginTop: showNewUserProfile ? 0 : '20px'}}>
      {!showNewUserProfile && (
        <Typography variant="subtitle2" style={{color: '#54708C'}}>
          {t('userInformationForm.messages.title')}
        </Typography>
      )}
      <Controller
        name={name}
        control={formMethods.control}
        disabled={readonlyMode}
        render={({field}) =>
          showNewUserProfile ? (
            <div className={`ml-${readonlyMode && showNewUserProfile ? 3 : 0}`}>
              <ControlledToggle
                disabled={readonlyMode}
                name="blocklist-notifications-toggle"
                checked={field.value}
                label={
                  field.value
                    ? t('userInformationForm.messages.blocklistNotificationsEnabled')
                    : t('userInformationForm.messages.blocklistNotificationsDisabled')
                }
                onChange={field.onChange}
                data-cy="blocklistNotificationsSwitch"
              />
            </div>
          ) : (
            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
              <Switch
                {...field}
                data-test-id="blocklistNotificationsSwitch"
                disabled={readonlyMode}
                disableRipple={true}
                classes={{
                  root: classes.switchRoot,
                  track: clsx({
                    [classes.trackSwitchBase]: true,
                    [classes.disabledTrack]: readonlyMode,
                    [classes.enabledTrack]: !readonlyMode
                  }),
                  thumb: classes.thumb,
                  switchBase: clsx({
                    [classes.disabledSwitchBase]: readonlyMode,
                    [classes.enabledSwitchBase]: !readonlyMode
                  })
                }}
                checked={field.value}
                inputProps={{'aria-label': 'secondary checkbox'}}
              />
              <Typography variant="subtitle2" style={{color: '#54708C'}}>
                {field.value
                  ? t('userInformationForm.messages.blocklistNotificationsEnabled')
                  : t('userInformationForm.messages.blocklistNotificationsDisabled')}
              </Typography>
            </div>
          )
        }
      />
    </Box>
  )
}
